// Colors used to visually distinguish multiple semesters in a combined teacher schedule.
// Chosen to not conflict with lesson type colors (blue, green, orange).
export const SEMESTER_COLORS = [
    '#7c3aed', // purple
    '#db2777', // pink
    '#00bcd4', // cyan
    '#795548', // brown
];